import { css } from 'styled-components';

export const CssBase = css`
  html,
  body {
    scroll-behavior: smooth;
  }

  body {
    height: auto;
  }
`;
